import React, { useState } from 'react'

import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import Typography from 'components/atoms/Typography'
import VideoCard from 'components/molecules/VideoCard'
import VideoModal from 'components/molecules/VideoModal'

import StartTestLink from 'components/pages/AptitudeLanding/StartTestLink'

import config from 'config'

const { assets_url: assetsUrl } = config

const videoSrc = 'https://www.youtube.com/embed/WIuL3by9FO0'

const AptitudeIntro = () => {
  const [showVideo, setShowVideo] = useState(false)

  return (
    <div className="aptitude-intro">
      <SectionContainer
        className="aptitude-intro__section"
        paddingTop={80}
        backgroundColor="#003399"
      >
        <Container className="aptitude-intro__container">
          <Row>
            <Col md="5">
              <VideoCard
                video={{
                  source: videoSrc,
                  thumbnail: `${assetsUrl}/assets/img/aptitude/aptitude-video-thumb.jpg`,
                }}
                onClick={() => setShowVideo(true)}
              />
            </Col>
            <Col md={{ size: 7, order: 'first' }}>
              <Typography component="h1" variant="title" className="aptitude-intro__title">
                Bingung dengan Masa Depan? <br/>
                Ikut Aja Tes Minat Bakat! <span className="highlighted">GRATIS</span>
              </Typography>
              <Typography component="p" variant="body" className="aptitude-intro__desc">
                Lebih dari <span className="text-bold">180.000 siswa</span> dari <span className="text-bold">13.000 sekolah</span> telah menemukan jurusan dan karier yang cocok melalui Tes Minat Bakat Quipper Campus. Sekarang giliran kamu, <span className="text-italic">yuk</span> coba sekarang dan lihat langsung hasilnya!
              </Typography>
              <StartTestLink/>
            </Col>
          </Row>
          <div className="aptitude-intro__dashed-border" />
        </Container>
      </SectionContainer>
      <VideoModal
        isOpen={showVideo}
        onVideoClose={() => setShowVideo(false)}
        videoSource={videoSrc}
      />
      <style jsx global>
        {`
          .aptitude-intro {
            background-color: #003399;
            &__section {
              background: url('${assetsUrl}/assets/img/aptitude/particle-background-x1.png');
              background-position: center left 20%;
              background-repeat: no-repeat;
              @media screen and (min-width: 768px) {
                background-position: center right;
              }
            }
            &__title,
            &__desc {
              color: #fff !important;
            }
            &__desc {
              margin-bottom: 32px !important;
            }
            &__container {
              padding-bottom: 80px;
              position: relative;
              @media screen and (min-width: 768px) {
                padding-bottom: 120px;
              }
            }
            &__dashed-border {
              width: 100%;
              position: absolute;
              bottom: 0;
              border-bottom: dashed 2px #fff;
            }
            :global(.video-card) {
              position: relative;
              padding-bottom: 56.25%; /* 16:9 */
              padding-top: 25px;
              height: 0;
              @media screen and (min-width: 768px) {
                margin: 16px;
              }
            }
            :global(.video-card__thumbnail) {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              max-height: 320px;
            }
            :global(.video-card__thumbnail-img) {
              max-height: 100%;
              height: 100%;
            }
            :global(.video-card__play-btn>svg) {
              height: 64px;
              width: 64px;
            }
          }
          .text-bold {
            font-weight: bold;
          }
          .text-italic {
            font-style: italic;
          }
          .highlighted {
            background-image: linear-gradient(120deg, #fc7d20 0%, #fc7d20 100%);
            background-repeat: no-repeat;
            background-size: 100% 0.2em;
            background-position: 0 88%;
          }
        `}
      </style>
    </div>
  )
}

export default AptitudeIntro
